import React from 'react'
import { Modal } from 'react-bootstrap'
import { observer } from 'mobx-react'
import { i18nTranslate } from 'src/utils'
import { currentMonthV2 } from 'src/deps'
import { LoyaltyMFEContainer } from 'src/views/components/LoyaltyMFE/LoyaltyMFEContainer'
import './styles.scss'

/**
 * FreeGiftsModal component renders a modal
 * with gifts details.
 *
 * Props:
 * - show: Boolean to show/hide modal
 * - onHide: Callback to hide modal
 * - subscriptions: Object with subscriptions data
 */
@observer
class OrderSkipModal extends React.Component {
  skipSkipment = () => {
    const {
      ProcessDate,
      isSkipmentSkip,
      skipSkipment,
      onHide,
      currentProcessDate,
      minFrequencyPeriod,
    } = this.props
    const month = currentProcessDate.getMonth() + 1
    skipSkipment(ProcessDate, !isSkipmentSkip, month)
    onHide('', true)
  }

  render() {
    const {
      currentProcessDate = new Date(),
      isSkipmentSkip = false,
      itemPrice = 0,
      minFrequencyPeriod = 1,
    } = this.props
    let currentDate = currentProcessDate
    const tittle = !isSkipmentSkip
      ? i18nTranslate(
          'subscription.shipmentSkip',
          'Do you want to skip your upcoming shipment?'
        )
      : i18nTranslate(
          'subscription.shipmentUnSkip',
          'Do you want to Un skip your shipment?'
        )
    const continueBtnText = isSkipmentSkip
      ? i18nTranslate(
          'subscription.shipmentUnSkipConfirm',
          'Yes, Unskip my shipment'
        )
      : i18nTranslate(
          'subscription.shipmentSkipConfirm',
          'Yes, skip my shipment'
        )
    const backBtnText = isSkipmentSkip
      ? i18nTranslate('subscription.shipmentUnSkipBack', 'Nevermind')
      : i18nTranslate(
          'subscription.shipmentSkipBack',
          'Nevermind, keep my order date'
        )
    let nextProcessDate = new Date(currentDate)
    const option = {
      // timeZone: 'UTC',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }
    const displayDate = currentProcessDate.toLocaleString('default', option)
    nextProcessDate.setMonth(nextProcessDate.getMonth() + minFrequencyPeriod)
    const displayNextDate = nextProcessDate.toLocaleString('default', option)
    const currentMonth = currentMonthV2()
    const selectedMonth = currentDate.getMonth()
    const showLoyaltyAlert = selectedMonth === currentMonth + 1
    return (
      <Modal
        {...this.props}
        size="md"
        className="skip-order-modal-container"
        centered>
        <Modal.Header
          closeButton
          data-testid="qa-subscription-shipment-header-wrapper">
          <Modal.Title className="skip-modal-question">{tittle}</Modal.Title>
        </Modal.Header>
        {!isSkipmentSkip && showLoyaltyAlert && (
          <LoyaltyMFEContainer
            componentName="App"
            isFrom="SKIP"
            itemValue={itemPrice}
          />
        )}
        <Modal.Body>
          {!isSkipmentSkip && (
            <div
              className="skipped-date-details"
              data-testid="qa-sub-skipment-details">
              <span data-testid="qa-sub-skipment-title">
                {i18nTranslate(
                  'subscription.shipmentSkipDetails',
                  'Skipping your shipment will skip all items on this processing day. Your Nu Skin Rewards eligibility may be affected by making this change.'
                )}
              </span>
            </div>
          )}
          {!isSkipmentSkip && (
            <div className="d-flex skipped-date-detail-section">
              <div data-testid="qa-sub-skipment-original-date">
                {i18nTranslate(
                  'subscription.shipmentOriginalDate',
                  'Original order date'
                )}
                {': '}
                <span className="skipped-date">{displayDate}</span>
              </div>
              <div data-testid="qa-sub-skipment-next-date">
                {i18nTranslate(
                  'subscription.shipmentNextOrderDate',
                  'Next order date for these items'
                )}
                {': '}
                <span className="skipped-date">{displayNextDate}</span>
              </div>
            </div>
          )}
          <div className="skip-order-button-container">
            <button
              className="skip-modal-button-continue"
              data-testid="qa-sub-skipment-continue-button"
              onClick={() => this.skipSkipment()}>
              {continueBtnText}
            </button>
            <button
              className="skip-modal-button-back"
              data-testid="qa-sub-skipment-back-button"
              onClick={() => this.props.onHide(isSkipmentSkip)}>
              {backBtnText}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export { OrderSkipModal }
export default OrderSkipModal
